<template lang="pug">
AppDialog#past-edit-recurring-job-dialog(
  show
  size="smedium"
  has-footer
  append-to-body
  title="Edit recurring job"
  @close="$emit('cancel')"
)
  p These changes will only be applied to this job

  template(slot="footer")
    AppButton.mr-15(@click.stop="cancel")
      | Cancel
    AppButton(
      type="primary"
      @click.stop="confirm"
    )
      | Save
</template>

<script>
export default {
  name: 'WorkOrdersEditPastJobConfirmDialog',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>
